import { h } from 'preact';
import * as BaseComp from 'components/bolt/button/button.js';
import { accessNested, joinClasses } from 'utils/utils';
import HTML from 'components/core/html/html';
import s from 'components/bolt/button/button.sss';

export default class Button extends BaseComp.default {
	render(props) {
		const {
			type,
			htmlType,
			active,
			class: className,
			activeClass,
			style,
			trigger,
			onMouseEnter,
			onMouseLeave,
			onMouseOut,
			onMouseDown,
			onKeyDown,
			onFocus,
			tabIndex,
			disabled,
			children,
			ariaLabel,
			conjoined,
			conjoinedTrigger
		} = props;

		if (type && !this.supportedTypes.includes(type)) {
			console.error(`Bolt.Button does not support a type of ${type}. Supported types are: ${this.supportedTypes.join(', ')}`);
			return;
		}

		const backgroundColor = accessNested(style, 'backgroundColor');

		if (conjoined) {
			children.push((
				<HTML
					ref={ref => this.conjoinedButton = ref}
					class={s.buttonLabel}
					markdown
					content={conjoined.label}
				/>
			));
		}

		return (
			<button
				class={joinClasses(s.container, active && s.active, backgroundColor && s.noHover, s[type], className, active && activeClass, conjoined && s.conjoined)}
				style={style}
				onClick={e => {
					if (this.conjoinedButton?.base?.contains(e.target)) {
						return conjoinedTrigger();
					}
					trigger(e);
				}}
				onMouseEnter={onMouseEnter}
				onMouseLeave={onMouseLeave}
				onMouseDown={onMouseDown}
				onMouseOut={onMouseOut}
				onKeyDown={onKeyDown}
				onFocus={onFocus}
				disabled={disabled}
				tabIndex={tabIndex}
				ariaLabel={ariaLabel}
				type={htmlType}
			>
				{children}
			</button>
		);
	}
}
